const PERMISSION_KEY= "core:billing_transaction";
const PAGE_URL = {
    BILLING_TRANSACTION_PAGE: "/admin/core/billing-transaction"
}

export {PERMISSION_KEY, PAGE_URL}

